import React from 'react';
import BtnPrimary from "../../../shared/ui/button/primary/BtnPrimary";

const BtnRowActions = ({savedWeek = false, isSalvageable = false, clickHandler}: {
    clickHandler: (action: string) => void,
    savedWeek?: boolean
    isSalvageable?: boolean
}) => {

    return (
        <div className={'d-flex gap-2 btn-row-calendar'}>

            <BtnPrimary title="Congela prospetto" icon={'./assets/icons/freeze.svg'} disabled={!isSalvageable}
                        variant={'outline-primary'} className={'text-primary'} onClick={() => clickHandler('freeze')}>Congela
                prospetto</BtnPrimary>

            <BtnPrimary title="Salva" icon={'./assets/icons/save.svg'}
                        disabled={savedWeek}
                        variant={'outline-primary'} className={'text-indigo-500 border-indigo-500'}
                        onClick={() => clickHandler('save')}>Salva modello</BtnPrimary>

            <BtnPrimary title="Carica modello" icon={'./assets/icons/upload.svg'}
                        disabled={savedWeek}
                        variant={'outline-primary'} className={'text-green-500 border-green-500'}
                        onClick={() => clickHandler('load')}>Carica Modello</BtnPrimary>

            <BtnPrimary title="Stampa" icon={'./assets/icons/print.svg'} disabled={false}
                        variant={'outline-primary'} className={'text-cyan-500 border-cyan-500'}
                        onClick={() => clickHandler('print')}></BtnPrimary>

            <BtnPrimary title="Resetta" icon={'./assets/icons/delete.svg'}

                        variant={'outline-primary'} className={'text-red-500 border-red-500'}
                        onClick={() => clickHandler('reset')}></BtnPrimary>

        </div>
    );
};

export default BtnRowActions;
